module.exports = __webpack_public_path__ + "img/payment-promise.9fc0f57.svg";